import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { COMPANY } from "@/data/legal";

export const Footer = () => {
  const { footer: f, branding } = useContent();

  return (
    <footer className="foot dk" data-testid="footer">
      <div className="wrap">
        <div className="row">
          {f?.email && (
            <span>
              <a href={`mailto:${f.email}`} data-testid="footer-email-link">{f.email}</a>
            </span>
          )}
          {f?.instagram && (
            <span>
              <a href={f.instagram_url || "#"} target="_blank" rel="noreferrer" data-testid="footer-instagram-link">{f.instagram}</a>
            </span>
          )}
          {f?.web && (
            <span>
              <a href={f.web_url || "#"} target="_blank" rel="noreferrer" data-testid="footer-web-link">{f.web}</a>
            </span>
          )}
          {f?.meta && <span>{f.meta}</span>}
        </div>

        <span className="big" aria-hidden="true">
          {branding?.logo_text || "TAANDEM"}<i>.</i>
        </span>

        <div className="row" style={{ marginTop: 28, opacity: 0.6 }}>
          <span>© {new Date().getFullYear()} {COMPANY.razon}</span>
          <span style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
            <Link to="/aviso-legal" data-testid="footer-aviso-legal">Aviso legal</Link>
            <Link to="/privacidad" data-testid="footer-privacidad">Privacidad</Link>
            <Link to="/cookies" data-testid="footer-cookies">Cookies</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
